function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114.3 57.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "0 57.5 94.7 57.5 114.3 0 21.4 0 0 57.5",
    style: {
      fill: "#12649f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4,44.5l-1.3-7.6h-11.4l-3.5,7.6h-5.3l15.1-31.5h7l5.8,31.5h-6.4ZM52.5,32.5l-2.5-14-6.5,14h9Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.5 44.5 71.8 13 77.6 13 72.3 44.5 66.5 44.5",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.cff8fc2219c2e7dc546b0a962b8300e6.svg";
export { ForwardRef as ReactComponent };